import { handleActions } from 'redux-actions'
import * as type from './type'


export const initialState = {
    fetching: false,
    error: null,
}


export default handleActions({
    [type.UPLOAD_CSV_REQUEST]: (state, action) => {
        return {
            ...state,
            fetching: true,
            error: null,
        }
    },
    [type.UPLOAD_CSV_ERROR]: (state, action) => {
        const { error } = action.payload
        return {
            ...state,
            fetching: false,
            error,
        }
    },
    [type.UPLOAD_CSV_SUCCESS]: (state, action) => {
        return {
            ...state,
            fetching: false,
        }
    },

}, initialState)



// WEBPACK FOOTER //
// ./src/modules/foil/state/overview/csv-upload/reducer.js